import { BaseUrlFormatter } from "../../../base";
export class SingleEventUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(request) {
        if (request.categoryId) {
            return `v1/events/${request.eventId}/categories/${request.categoryId}`;
        }
        return `v1/events/${request.eventId}/categories`;
    }
}
//# sourceMappingURL=SingleEventUrlFormatter.js.map